export const buildDocumentTitle = ({
  pageTitle,
  tabTitle,
  siteTitle,
}: {
  pageTitle?: string
  tabTitle?: string
  siteTitle: string
}): string => {
  const segments = [tabTitle, pageTitle, siteTitle].filter(
    (segment): segment is string => Boolean(segment),
  )
  return segments.join(' | ')
}
